import { useAccountFeaturesQuery } from 'syf-api';
import { useActivityContext } from '../context/activity-store';
import { Platform } from '../services/mma-config';
var useAccountFeatures = function (_a) {
    var selectedAccount = _a.selectedAccount, selectedPlatform = _a.selectedPlatform;
    var _b = useActivityContext(), accountId = _b.accountId, accountIdType = _b.accountIdType, config = _b.config;
    var currentAccountId = (accountId || selectedAccount);
    // Skip API call if platform is PEAKS
    var isPeaks = selectedPlatform === Platform.PEAKS;
    var accountFeatures = useAccountFeaturesQuery({
        config: config,
        keyProps: {
            accountId: currentAccountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            enabled: Boolean(currentAccountId && config && !isPeaks)
        }
    }).data;
    return accountFeatures;
};
export default useAccountFeatures;
//# sourceMappingURL=use-account-features.js.map